import React, {PropTypes} from 'react';
import './style.scss';

const ButtonGroup = ({children}) => {
    return (
        <div className="right-align btn-group">
            {children}
        </div>
    );
};

ButtonGroup.propTypes = {
    children: PropTypes.node
};

export default ButtonGroup;